import "./bladeSelectorEditorial.css";
import MindGameBrand from "./MindGameBrand";
import { BLADE_ARTWORK } from "../utils/bladeArtwork";

const ROOT = `${process.env.PUBLIC_URL}/redesign/images/redesign/blade_v1`;
const V2_ROOT = `${process.env.PUBLIC_URL}/redesign/images/redesign/blade_v2`;
const image = (folder, file) => `${ROOT}/${folder}/${file}`;
export const EDITORIAL_TEXTURES = {
  "--bs-base": `url("${image("art", "01_charcoal_grain_base.png")}")`,
  "--bs-grain": `url("${image("art", "05_global_print_grain_overlay.png")}")`,
  "--bs-sheen": `url("${image("panels", "03_active_panel_sheen.svg")}")`,
};
const BLADE_ART = Object.values(BLADE_ARTWORK);
const DESCRIPTIONS = [
  ["SHORT-FORM", "VIDEO", "Cultural momentum"],
  ["SEARCH", "AND VIDEO", "Discover what resonates"],
  ["LIVE STREAM", "VIEWERS", "Attention in real time"],
  ["ALL-PLATFORM GAMING ATTENTION", "THE INDEX / WEEKLY", "Explore the market"],
  ["PC PLAYERS", "& DEMAND", "Understand player activity"],
  ["CONSOLE", "ACTIVITY", "Track the ecosystem"],
  ["COMMUNITY", "SIGNALS", "Listen to the conversation"],
];
const TRACKS = [
  "M980 410H1750",
  "M1220 240V1010",
  "M290 930H900",
  "M70 802V948",
];

export function EditorialBladeContent({ dashboard, index, selected, locked }) {
  const description = DESCRIPTIONS[index];
  const mindshare = dashboard.route === "/mindshare";
  return (
    <>
      <span className="bs-artwork" aria-hidden="true">
      <span className="bs-blade-grain" />
      <img className={`bs-blade-art${index === 3 ? " bs-blade-art-hero" : ""}`}
        src={`${V2_ROOT}/${BLADE_ART[index]}`} alt="" aria-hidden="true" draggable="false" />
      <span className="bs-art-integration" aria-hidden="true" />
      </span>
      <svg className="bs-frame bs-frame-inactive" viewBox="0 0 220 620" preserveAspectRatio="none" aria-hidden="true">
        <rect x="1.5" y="1.5" width="217" height="617" fill="none" stroke="#ece6da" strokeOpacity=".42" strokeWidth="1" vectorEffect="non-scaling-stroke" />
        <path d="M0 520H220" stroke="#ece6da" strokeOpacity=".16" vectorEffect="non-scaling-stroke" />
      </svg>
      <svg className="bs-frame bs-frame-active" viewBox="0 0 310 700" preserveAspectRatio="none" aria-hidden="true">
        <rect x="2" y="2" width="306" height="696" fill="none" stroke="#ece6da" strokeOpacity=".65" strokeWidth="1" vectorEffect="non-scaling-stroke" />
        <path d="M3 3V697" className="bs-edge-left" strokeWidth="3" vectorEffect="non-scaling-stroke" />
        <path d="M307 3V697" className="bs-edge-right" strokeWidth="3" vectorEffect="non-scaling-stroke" />
        <path d="M3 16V3H17" className="bs-edge-left" fill="none" strokeWidth="2" vectorEffect="non-scaling-stroke" />
        <path d="M293 697H307V684" className="bs-edge-right" fill="none" strokeWidth="2" vectorEffect="non-scaling-stroke" />
        <path d="M3 3V697" className="bs-border-trace bs-edge-left" pathLength="1" vectorEffect="non-scaling-stroke" />
        <path d="M307 697V3" className="bs-border-trace bs-edge-right" pathLength="1" vectorEffect="non-scaling-stroke" />
      </svg>
      <span className="bs-blade-sheen" aria-hidden="true" />
      <span className="bs-number">{String(index + 1).padStart(2, "0")}<span className="bs-primary"> / {dashboard.route === "/mindshare" ? "PRIMARY INDEX" : "INTELLIGENCE CHANNEL"}</span></span>
      <span className="bs-blade-heading">{dashboard.name}</span>
      <span className="bs-platform-mark" aria-hidden="true">
        <img src={mindshare ? `${process.env.PUBLIC_URL}/redesign/logos/icon/mindGAME Tree Logo.png` : `${process.env.PUBLIC_URL}/${dashboard.icon}`} alt="" draggable="false" />
      </span>
      <span className="bs-label-block">
        <span className="bs-description">{description[0]}<br />{description[1]}</span>
        <span className="bs-label-underline" aria-hidden="true" />
        <span className="bs-label-edge" aria-hidden="true" />
      </span>
      <span className="bs-action"><span>{selected ? description[2] : "EXPLORE"}</span><span aria-hidden="true">→</span></span>
      <span className="bs-status">{selected ? (locked ? "ACCESS / RESTRICTED" : "SELECTED / ENTER") : "DATA / SIGNAL"}</span>
    </>
  );
}

export function SelectorScenery({ paused }) {
  return (
    <div className="bs-scenery" aria-hidden="true">
      <img className="bs-page-grid" src={image("art", "08_selector_page_grid.svg")} alt="" />
      <img className="bs-page-tracks" src={image("art", "09_selector_signal_tracks.svg")} alt="" />
      <img className="bs-page-marks" src={image("art", "10_selector_micro_marks.svg")} alt="" />
      <svg className={`bs-signals${paused ? " is-paused" : ""}`} viewBox="0 0 1920 1080" preserveAspectRatio="none">
        {TRACKS.map((track, index) => (
          <g key={track} className="bs-signal" style={{ "--bs-delay": `${index * 2.5 - 10}s` }}>
            <path d={track} pathLength="1" />
            <circle cx={[1750, 1220, 900, 70][index]} cy={[410, 1010, 930, 948][index]} r="2" />
          </g>
        ))}
      </svg>
    </div>
  );
}

export default function BladeSelectorEditorial({ paused }) {
  return (
    <>
      <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Jura:wght@300;400;500;600;700&display=swap" />
      <SelectorScenery paused={paused} />
      <header className="bs-header">
        <div className="bs-brand">
          <MindGameBrand variant="color-ring" animated={false} />
        </div>
        <div className="bs-header-editorial">
          <div className="bs-system-heading"><span aria-hidden="true">&nbsp;</span><h1>CHOOSE A DASHBOARD</h1></div>
        </div>
      </header>
      <div className="bs-heading"><span>GAMING / INTELLIGENCE / PLATFORM</span></div>
      <footer className="bs-footer">
        <p className="bs-footer-origin">GAMES<br />DATA<br /><span>BIGGER<br />POTENTIAL</span></p>
      </footer>
    </>
  );
}
